import { Routes } from "@angular/router";

export const faqRoutes: Routes = [
    {
        path: 'faq',
        title: 'FAQ',
        loadComponent: () => import('./faq.component').then(m => m.FaqComponent),
        children: [
            {
                path: 'prospective-members',
                title: 'Prospective members',
                loadComponent: () => import('./prospective-members/prospective-members.component').then(m => m.ProspectiveMembersComponent)
            },
            {
                path: 'members',
                title: 'Members',
                loadComponent: () => import('./members/members.component').then(m => m.MembersComponent)
            },
            {
                path: 'prospective-producers',
                title: 'Prospective Businesses and Producers',
                loadComponent: () => import('./prospective-producers/prospective-producers.component').then(m => m.ProspectiveProducersComponent)
            }
        ]
    }
]
